module.exports = __webpack_public_path__ + "img/FinOps.d8f4a603.svg";